module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-001"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Tables")])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#renvlnk-030"
    }
  }, [_c('b', [_vm._v("Table 3-1. ")])]), _vm._v("TANs of Various Crudes")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#renvlnk-074",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 7-1. ")])]), _vm._v("Some Properties of Light Ends")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap8#renvlnk-093",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 8-1. ")])]), _vm._v("Cat Cracker Yields")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#renvlnk-103",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 9-1. ")])]), _vm._v("Alkylation Plant Yields")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap10#renvlnk-114",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 10-1. ")])]), _vm._v("Composition of Cat Reformer Feeds and Outturns")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap10#renvlnk-119",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 10-2. ")])]), _vm._v("Fixed Bed Cat Reformer Yields")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap11#renvlnk-132",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 11-1. ")])]), _vm._v("Typical Hydrocracker Yields")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap12#renvlnk-141",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 12-1. ")])]), _vm._v("Octane Improvement in a C5-C6 Isomerization Plant")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap13#renvlnk-147",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 13-1. ")])]), _vm._v("Typical Yields Cracking Flasher Bottoms")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap14#renvlnk-158",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 14-1. ")])]), _vm._v("Vapor Pressures")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap14#renvlnk-159",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 14-2.")])]), _vm._v(" Blending for Vapor Pressure")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap14#renvlnk-162",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 14-3.")])]), _vm._v(" Octane Numbers")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap14#renvlnk-163",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 14-4.")])]), _vm._v(" Blending for Octane Number")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap14#renvlnk-166",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 14-5.")])]), _vm._v(" Blending Characteristics of Ethers and Alcohols")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap18#renvlnk-201",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 18.1.")])]), _vm._v(" Typical Viscosities of Some Fluids")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap19#renvlnk-211",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 19-1.")])]), _vm._v(" Ethylene Plant Yields")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap20#renvlnk-227",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 20-1.")])]), _vm._v(" Refinery Yields")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap20#renvlnk-228",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 20-2.")])]), _vm._v(" Margins from Simple and Complex Refineries Medium Crude")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap20#renvlnk-229",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 20-3.")])]), _vm._v("Margins from Refining Heavy Crude")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap20#renvlnk-231",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 20-4.")])]), _vm._v(" U.S. Gulf Coast Refining Margins")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap20#renvlnk-232",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 20-5.")])]), _vm._v(" U.S. Gulf Coast Refinery Margins")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap22#renvlnk-249",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 22-1.")])]), _vm._v(" Heating Values")]), _c('p', {
    staticClass: "txt_courant_gauche retrait_gauche"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap22#renvlnk-250",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Table 22-2.")])]), _vm._v(" Thermal Efficiency")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30defbe2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre3.vue
// module id = 69
// module chunks = 0